import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { ActiveVendorsState } from "../../models/mp-common/active-vendors-state";

const initialState: ActiveVendorsState = {
	loading: true,
	allRetrieved: false
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.activeVendors.getApi, (state) =>
		_.merge(_.cloneDeep(state), { loading: true })
	),
	on(MpCommonActions.activeVendors.getSuccess, (state, action) => {
		const existing = _.cloneDeep(_.get(state, "vendors", []));
		const vendors = _.unionBy(action.vendors, existing, "id");
		return { vendors, loading: action.loading, allRetrieved: action.allRetrieved };
	}),
	on(MpCommonActions.activeVendors.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(MpCommonActions.activeVendors.invalidate, () => initialState),
	on(MpAdminActions.vendor.disableSuccess, (state, { id }) => {
		const vendors = _.cloneDeep(_.get(state, "vendors", []));
		const updatedVendors = vendors.filter((vendor) => vendor.id !== id);
		return { ...state, vendors: updatedVendors };
	})
);

export function activeVendorsReducer(
	state: ActiveVendorsState | undefined,
	action: Action
): ActiveVendorsState {
	return reducer(state, action);
}
